export enum PLAN {
    GENERAL_CHAT = "generalChat",
    POWER_UPS = "powerUps",
    SPOTIFY_LIST = "spotifyList",
    VIRTUAL_ROOM_RESERVATIONS = "virtualRoomReservations",
    PHYSICAL_ROOM_RESERVATIONS = "physicalRoomReservations",
    CUSTOM_AVATAR = "customAvatar", //No
    ALLOW_ALL_SPACE_MODELS = "allowAllSpaceModels", //No
    PET = "pet",
    NOTEPAD = "notepad",
    POSTER_WEB_LINK = "posterWebLink",
    WEBINAR = "webinar",
    NETWORKING = "networking",
    SHARE_MULTIPLE_SCREEN = "shareMultipleScreen", //No
    CUSTOM_BACKGROUND = "customBackground", //No
    LOCK_ROOM = "lockRoom",
    POLL = "poll",
    AGENDA = "agenda",
    MEETING_RECORDING = "meetingRecording",
    FOCUS_MODE = "focusMode",
    CHANGE_CAMERA_GRID = "changeCameraGrid",
    IA = "IA",
    PIN_MESSAGES = "pinMessages",
    GAMES = "games",
    GOOGLE_CALENDAR = "googleCalendar",
    OUTLOOK_CALENDAR = "outlookCalendar",
    MICROSOFT_TEAMS = "microsoftTeams", //No
    ANNOUNCEMENT = "announcement",
    METRICS = "metrics",
    MULTI_WEBINAR = "multiWebinar",
    USERS_GROUPS = "usersGroups",
    EVENT_LOGS = "eventLogs",
    SCHEDULE_ANNOUNCEMENT = "scheduleAnnouncement",
    BUSINESS_CARD = "businessCard",
    COPY_OR_SEND_BUSINESS_CARD = "copyOrSendBusinessCard",
    AUTOVIDEO = "autoVideo", //No
    SSO = "sso" //No
  }